export const teacher=[
    {
        path: 'teacher/statistical',
        component: () => import('@/teacher/CommonData.vue')
    }
]